import { Container, Eyebrow, Section, Reveal } from "./common";
import { LGEC_ROWS } from "../data/content";

export const MarcoLGEC = () => {
  return (
    <Section id="lgec" alt>
      <Container>
        <Reveal>
          <Eyebrow>Marco normativo · Posición institucional</Eyebrow>
          <h2 className="mt-5 font-serif font-light text-3xl sm:text-4xl lg:text-5xl tracking-tight text-stone-100">
            Nuestra posición ante la <span className="text-rc-sage italic">LGEC</span>
          </h2>
          <p className="mt-6 max-w-3xl text-stone-400 font-light leading-relaxed">
            La Ley General de Economía Circular (DOF, enero 2026) no es solo una obligación legal — es la
            oportunidad más grande que han tenido los municipios mexicanos para transformar su gestión de
            residuos en un modelo sostenible, rentable y replicable. Raíz Commerce existe para acompañar esa
            transición.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-12 overflow-x-auto rounded-2xl border border-rc-border">
            <table className="w-full text-left" data-testid="lgec-table">
              <thead>
                <tr className="bg-rc-card">
                  <th className="p-5 font-mono text-xs uppercase tracking-wider text-rc-sage">Artículo LGEC</th>
                  <th className="p-5 font-mono text-xs uppercase tracking-wider text-rc-sage">Mandato</th>
                  <th className="p-5 font-mono text-xs uppercase tracking-wider text-rc-sage">Nuestra contribución</th>
                </tr>
              </thead>
              <tbody>
                {LGEC_ROWS.map((r) => (
                  <tr key={r.art} className="border-t border-rc-border hover:bg-rc-card/60 transition-colors">
                    <td className="p-5 align-top">
                      <span className="inline-block text-xs font-mono px-3 py-1 rounded-full bg-rc-forest/25 text-rc-sage border border-rc-forest/40 whitespace-nowrap">
                        {r.art}
                      </span>
                    </td>
                    <td className="p-5 align-top text-sm text-stone-200 font-light">{r.mandato}</td>
                    <td className="p-5 align-top text-sm text-stone-400 font-light leading-relaxed">{r.contrib}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <p className="mt-6 text-xs text-stone-600 font-light">
          Referencias conforme al marco vigente de la LGEC (DOF 19-01-2026); en actualización conforme se
          publique su reglamento.
        </p>
      </Container>
    </Section>
  );
};
